import { Link } from "react-router-dom";

const columns = [
  {
    name: "Edit",
    sortable: false,
    cell: (row) => {
      return <Link to={`/click-to-fly/routes/${row._id}`}>Edit</Link>;
    },
    width: "70px",
  },
  {
    name: "Departure",
    selector: "departureAirport.code",
    sortable: true,
    width: "120px",
    cell: (row) => {
      return row.departureAirport?.code || "—";
    },
  },
  {
    name: "Arrival",
    selector: "arrivalAirport.code",
    sortable: true,
    width: "120px",
    cell: (row) => {
      return row.arrivalAirport?.code || "—";
    },
  },
  {
    name: "Route",
    sortable: false,
    width: "200px",
    cell: (row) => {
      const depCode = row.departureAirport?.code || "?";
      const arrCode = row.arrivalAirport?.code || "?";
      return `${depCode} → ${arrCode}`;
    },
  },
  {
    name: "Departure Region",
    sortable: false,
    width: "150px",
    cell: (row) => {
      return row.departureRegion?.name || "—";
    },
  },
  {
    name: "Arrival Region",
    sortable: false,
    width: "150px",
    cell: (row) => {
      return row.arrivalRegion?.name || "—";
    },
  },
  {
    name: "Aircraft Types",
    sortable: false,
    width: "120px",
    cell: (row) => {
      const enabledCount = row.eligibleAircraftTypes?.filter(
        (type) => type.enabled
      ).length || 0;
      const totalCount = row.eligibleAircraftTypes?.length || 0;
      return `${enabledCount}/${totalCount} enabled`;
    },
  },
  {
    name: "Created",
    selector: "createdAt",
    sortable: true,
    width: "150px",
    cell: (row) => {
      if (row.createdAt) {
        return new Date(row.createdAt).toLocaleDateString();
      }
      return "—";
    },
  },
];

export default columns;

